module.exports = __webpack_public_path__ + "img/single-dependant.a2182ba9.svg";